/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

/* eslint-disable spire/fenced-imports */
import { RecursivePartial } from "@insite/shell/Components/Shell/StyleGuide/Types";
import { xBaseTheme } from "@monsma/XDL/types";

import "@monsma/XDL/PreStyle/loadingOverlay";
import accordion from "./accordion";
import breadcrumbs from "./breadcrumbs";
import breakpoints from "./breakpoints";
import button from "./button";
import checkbox from "./checkbox";
import clickable from "./clickable";
import colors from "./colors";
import dataTable from "./dataTable";
import datePicker from "./datePicker";
import drawer from "./drawer";
import dynamicDropdown from "./dynamicDropdown";
import fieldSet from "./fieldSet";
import fileUpload from "./fileUpload";
import focus from "./focus";
import formField from "./formField";
import globalStyle from "./globalStyle";
import helpers from "./helpers";
import icon from "./icon";
import lazyImage from "./lazyImage";
import link from "./link";
import lists from "./lists";
import loadingSpinner from "./loadingSpinner";
import menu from "./menu";
import modal from "./modal";
import overflowMenu from "./overflowMenu";
import pagination from "./pagination";
import panelMenu from "./panelMenu";
import radio from "./radio";
import select from "./select";
import shadows from "./shadows";
import tab from "./tab";
import tag from "./tag";
import textArea from "./textArea";
import textField from "./textField";
import toast from "./toast";
import tokenExFrame from "./tokenExFrame";
import tooltip from "./tooltip";
import transition from "./transition";
import translate from "./translate";
import typography from "./typography";
import zIndex from "./zIndex";

export default {
    breakpoints,
    colors,
    // focus,
    shadows,
    // transition,
    globalStyle,
    typography,
    zIndex,
    accordion,
    breadcrumbs,
    button,
    checkbox,
    clickable,
    dataTable,
    datePicker,
    // drawer,
    dynamicDropdown,
    // fileUpload,
    formField,
    // fieldSet,
    // icon,
    link,
    // lists,
    // lazyImage,
    // loadingSpinner,
    // menu,
    modal,
    overflowMenu,
    pagination,
    // panelMenu,
    radio,
    select,
    // tab,
    tag,
    // textField,
    // tokenExFrame,
    // textArea,
    toast,
    tooltip,
    // translate,
    helpers,
} as RecursivePartial<xBaseTheme>;
